import { type } from 'arktype'

import { amountSchema, amountToString, newAmount } from '@orus.eu/amount'
import {
  AbstractDimension,
  type DimensionValidationProblem,
  dimensionValidationFailure,
  type LooselyTypedValue,
} from '@orus.eu/dimensions'
import { type Result, success } from '@orus.eu/result'

export const MRPW_MIN_DEROGATION_ASSETS_VALUE = newAmount(250_000)
export const MRPW_MAX_DEROGATION_ASSETS_VALUE = newAmount(500_000)

export const MrpwDerogationAssetsDefaultValue = 'DEFAULT'

export const mrpwDerogationAssetsValueArkType = type({
  type: "'amount'",
  amount: amountSchema,
}).or({
  type: "'default'",
})

export type MrpwDerogationAssetsValue = typeof mrpwDerogationAssetsValueArkType.infer

export class MrpwDerogationAssetsValueDimension<NAME extends string> extends AbstractDimension<
  NAME,
  MrpwDerogationAssetsValue
> {
  override validateData(value: LooselyTypedValue): Result<MrpwDerogationAssetsValue, DimensionValidationProblem> {
    const result = mrpwDerogationAssetsValueArkType(value)
    if (result instanceof type.errors) {
      return dimensionValidationFailure(`Field ${this.name} is not valid`)
    }
    return success(result)
  }

  override formatToString(value: MrpwDerogationAssetsValue): string | undefined {
    return value.type === 'amount' ? amountToString(value.amount) : MrpwDerogationAssetsDefaultValue
  }
}

export const mrpwDerogationRangeAssetsValueArkType = type({
  min: amountSchema,
  max: amountSchema,
})

export type MrpwDerogationRangeAssetsValue = typeof mrpwDerogationRangeAssetsValueArkType.infer

export class MrpwDerogationRangeAssetsValueDimension<NAME extends string> extends AbstractDimension<
  NAME,
  MrpwDerogationRangeAssetsValue
> {
  override validateData(value: LooselyTypedValue): Result<MrpwDerogationRangeAssetsValue, DimensionValidationProblem> {
    const result = mrpwDerogationRangeAssetsValueArkType(value)
    if (result instanceof type.errors) {
      return dimensionValidationFailure(`Field ${this.name} is not valid`)
    }
    return success(result)
  }

  override formatToString(value: MrpwDerogationRangeAssetsValue): string | undefined {
    return `${amountToString(value.min)} - ${amountToString(value.max)}`
  }
}
